import { useEffect, useRef } from 'react';
import * as React from 'react';

export interface ITabListNavItemProps {
  id?: string;
  ariaControls?: string;
  index?: number;
  activeIndex?: number;
  focus?: boolean;
  disabled?: boolean;
  onActivate?: (activeIndex: number) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
}

function TabListNavItem({
  id = undefined,
  ariaControls = undefined,
  index = undefined,
  activeIndex = undefined,
  focus = false,
  disabled = false,
  onActivate = undefined,
  onKeyDown = undefined,
  children,
}: ITabListNavItemProps) {
  const navLinkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (focus && activeIndex === index) {
      navLinkRef.current?.focus();
    }
  }, [activeIndex, focus, index]);

  return (
    <li className="nav-item" role="presentation">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        ref={navLinkRef}
        id={id}
        role="tab"
        tabIndex={!disabled && index === activeIndex ? 0 : -1}
        aria-selected={!disabled && index === activeIndex}
        aria-controls={ariaControls}
        className={`nav-link ${index === activeIndex ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
        href="#"
        aria-disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          if (disabled) return;

          if (index !== undefined) {
            onActivate?.(index);
          }
        }}
        onKeyDown={(ev) => onKeyDown?.(ev)}
      >
        <span className="nav-link__inner-item" aria-live="polite">
          {children}
        </span>
      </a>
    </li>
  );
}

export default TabListNavItem;
